export default {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/Common/Sortable.js